import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Button, Snackbar, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import Input from "../../../atoms/Input";
import TextArea from "../../../atoms/Textarea";
import ContactDetailField from "../../../molecules/ContactDetailField";
import { useLocation } from "react-router-dom";
import DynamicCheckbox from "../../../molecules/DynamicCheckbox";
import DynamicText from "../../../molecules/DynamicText";
import PackingRequestPageDownload from "./download";
import PrintComponent from "../../PrintComponent";
import moment from "moment";
import MySignatureCanvas from "../../../molecules/signature_canvas";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DescriptionIcon from "@mui/icons-material/Description";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import CommentIcon from "@mui/icons-material/Comment";

const PackingRequestPagePreview = () => {
  const [surveyData, setSurveyData] = useState(null);
  const [formContent, setFormContent] = useState({});

  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [isSignCanvas, setSignCanvas] = useState(false);


  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const updateContent = (data) => {
    setIsLoading(true);

    let media = [];
    if (formContent?.clientSign != "") media[0] = formContent?.clientSign;

    const body = {
      formContentId: formContentId,
      content: data ? data : formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        if (data != undefined)
          setSnackbarMessage("Signature has been added successfully!");
        else
          setSnackbarMessage(
            "Delivery Request Form has been updated successfully!"
          );

        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
        setMediaKeysToSend([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    setMediaKeysToSend([]);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        setIsLoading(false);
      })
      .catch((error) => {
        setIsValid(false);
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);



  const [uploadText, setUploadText] = useState("Upload Sign");

  //
  const uploadFile = async (file) => {
    setUploadText("Uploading...");
    const fd = new FormData();
    fd.append("image", file);

    imageUploadClientPreview(fd, surveyId, formId, email, token)
      .then((res) => {
        let values = { ...formContent };
        values.clientSign = res?.data?.data?.key;
        setFormContent(values);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setTimeout(() => {
          updateContent(values);
        }, 2000);
        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setUploadText("Upload Sign");

        setIsLoading(false);
      });

  };

  return (
    <>
      {isValid ? (
        <PremiumPublicLayout
          title="Packing Request Form"
          hideBackButton={true}
          actions={
            <div className="d-flex gap-3">
              {!isEdit && (
                <Button
                  variant="contained"
                  onClick={() => {
                    setIsEdit(true);
                  }}
                  disabled={isLoading}
                  sx={{
                    textTransform: "none",
                    borderRadius: "var(--radius-md)",
                    padding: "10px 24px",
                    fontWeight: 700,
                    backgroundColor: "var(--primary-color)",
                    boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                    "&:hover": { backgroundColor: "var(--primary-hover)" },
                  }}
                  startIcon={<NoteAltIcon />}
                >
                  Edit
                </Button>
              )}

              {formContent?.clientSign == "" && !isEdit && (
                <Button
                  variant="contained"
                  onClick={() => setSignCanvas(true)}
                  sx={{
                    textTransform: "none",
                    borderRadius: "var(--radius-md)",
                    padding: "10px 24px",
                    fontWeight: 700,
                    backgroundColor: "var(--primary-color)",
                    boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                    "&:hover": { backgroundColor: "var(--primary-hover)" },
                  }}
                >
                  Upload Sign
                </Button>
              )}

              {isEdit && (
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    getContent();
                    setIsEdit(false);
                  }}
                  disabled={isLoading}
                  sx={{
                    textTransform: "none",
                    borderRadius: "var(--radius-md)",
                    fontWeight: 700,
                    padding: "10px 24px",
                    border: "1px solid",
                  }}
                >
                  Cancel
                </Button>
              )}

              {isEdit && (
                <Button
                  variant="contained"
                  onClick={() => {
                    updateContent(formContent);
                  }}
                  disabled={isLoading}
                  sx={{
                    textTransform: "none",
                    borderRadius: "var(--radius-md)",
                    padding: "10px 32px",
                    fontWeight: 700,
                    backgroundColor: "var(--primary-color)",
                    boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
                    "&:hover": { backgroundColor: "var(--primary-hover)" },
                  }}
                >
                  Save
                </Button>
              )}

              {!isEdit && (
                <Button
                  variant="contained"
                  onClick={() => {
                    if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                      setIsLoading(true);
                    var tempTitle = document.title;
                    document.title = `Packing-Request-${
                      formContent?.customerName || "Document"
                    }-${moment().format("DD.MM.YYYY")}`;

                    // Standardized delay for print and title restoration
                    setTimeout(() => {
                      window.print();
                      setTimeout(() => {
                        document.title = tempTitle;
                        setIsLoading(false);
                      }, 2000);
                    }, 500);
                  }}
                  disabled={isLoading}
                  sx={{
                    textTransform: "none",
                    borderRadius: "var(--radius-md)",
                    padding: "10px 24px",
                    fontWeight: 700,
                    backgroundColor: "var(--text-main)",
                    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                    "&:hover": { backgroundColor: "#000" },
                  }}
                  startIcon={<DescriptionIcon />}
                >
                  Save as PDF
                </Button>
              )}
            </div>
          }
        >
          <PremiumCard sx={{ marginBottom: "32px" }}>
            <SectionHeader
              title="Customer Information"
              icon={<DescriptionIcon />}
            />
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <ContactDetailField
                  label="Customer Name"
                  isEdit={isEdit}
                  type="text"
                  minWidth={"150px"}
                  value={formContent?.customerName}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.customerName = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <ContactDetailField
                  label="Date"
                  isEdit={isEdit}
                  type="date"
                  minWidth={"150px"}
                  value={formContent?.date}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.date = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
            </Grid>
          </PremiumCard>

          <PremiumCard sx={{ marginBottom: "32px" }}>
            <SectionHeader title="Packing Details" icon={<LocalShippingIcon />} />
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <DynamicText
                  label="Packing Address"
                  textAreaLabel="Packing Address"
                  isEdit={isEdit}
                  value={formContent?.packingAddress}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.packingAddress = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
              
              <Grid item xs={12}>
                 <Typography className="mb-2 fw-bold text-primary">
                    Which dates and time suits you to start packing of your goods?
                 </Typography>
              </Grid>

              {isEdit ? (
                <>
                  <Grid item xs={12} md={6}>
                    <ContactDetailField
                      label="Packing Date"
                      isEdit={isEdit}
                      type="date"
                      value={formContent?.packingDate}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.packingDate = e.target.value;
                        setFormContent(values);
                      }}
                      minWidth={"150px"}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ContactDetailField
                      label="Packing Time"
                      isEdit={isEdit}
                      type="time"
                      value={formContent?.packingTime}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.packingTime = e.target.value;
                        setFormContent(values);
                      }}
                      minWidth={"150px"}
                    />
                  </Grid>
                </>
              ) : (
                <Grid item xs={12}>
                  <p className="mb-1 p-2 bg-light rounded">
                    {formContent?.packingDate} {formContent?.packingTime}
                  </p>
                </Grid>
              )}
            </Grid>
          </PremiumCard>

          <PremiumCard sx={{ marginBottom: "32px" }}>
            <SectionHeader
              title="Priorities & Requirements"
              icon={<DescriptionIcon />}
            />
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <DynamicCheckbox
                  label="Is there any vehicle/crew permission/security access/permit required for your residence?"
                  checkId1="check1"
                  checkLabel1="Yes"
                  checkId2="check2"
                  checkLabel2="No"
                  value1={formContent?.permissions}
                  value2={formContent?.permissions}
                  onChange1={(e) => {
                    let values = { ...formContent };
                    values.permissions = true;
                    setFormContent(values);
                  }}
                  onChange2={(e) => {
                    let values = { ...formContent };
                    values.permissions = false;
                    setFormContent(values);
                  }}
                  disabled={isEdit ? false : true}
                />
                {formContent?.permissions && (
                  <div className="mt-3 ps-4 border-start border-primary border-3">
                    <DynamicText
                      label="If yes, please advise requirement:"
                      textAreaLabel="Requirement..."
                      isEdit={isEdit}
                      value={formContent?.adviseRequirement}
                      onChange={(e) => {
                        let values = { ...formContent };
                        values.adviseRequirement = e.target.value;
                        setFormContent(values);
                      }}
                    />
                  </div>
                )}
              </Grid>
              
              <Grid item xs={12}>
                 <hr className="my-2 text-muted" />
              </Grid>
              
              <Grid item xs={12}>
                <DynamicText
                  label="1st priority items to pack:"
                  textAreaLabel="1st priority items..."
                  isEdit={isEdit}
                  value={formContent?.firstPriority}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.firstPriority = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <DynamicText
                  label="2nd priority items to pack:"
                  textAreaLabel="2nd priority items... "
                  isEdit={isEdit}
                  value={formContent?.secondPriority}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.secondPriority = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <DynamicText
                  label="3rd priority items to pack:"
                  textAreaLabel="3rd priority items..."
                  isEdit={isEdit}
                  value={formContent?.thirdPriority}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.thirdPriority = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
            </Grid>
          </PremiumCard>

          <PremiumCard sx={{ marginBottom: "32px" }}>
            <SectionHeader
              title="Remarks & Instructions"
              icon={<CommentIcon />}
            />
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <DynamicCheckbox
                  label="Residence’s rooms or items marked/labeled with suitable Info/Numbers/Colors are not going to pack up?"
                  checkId1="labeled_items_yes"
                  checkLabel1="Yes"
                  checkId2="labeled_items_no"
                  checkLabel2="No"
                  value1={formContent?.packUpSuitable}
                  value2={formContent?.packUpSuitable}
                  onChange1={(e) => {
                    let values = { ...formContent };
                    values.packUpSuitable = true;
                    setFormContent(values);
                  }}
                  onChange2={(e) => {
                    let values = { ...formContent };
                    values.packUpSuitable = false;
                    setFormContent(values);
                  }}
                  disabled={isEdit ? false : true}
                />
              </Grid>
              <Grid item xs={12}>
                <DynamicText
                  label="Customer Suggestions/Remarks if any:"
                  textAreaLabel="Customer Suggestions..."
                  isEdit={isEdit}
                  value={formContent?.suggestions}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.suggestions = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <DynamicText
                  label="Office Instructions/remarks:"
                  textAreaLabel="Office Instructions/remarks..."
                  isEdit={isEdit}
                  value={formContent?.officeInstructions}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.officeInstructions = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
            </Grid>
          </PremiumCard>

          <PremiumCard>
            <SectionHeader title="Signatures" icon={<DescriptionIcon />} />
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6} className="text-center">
                <div
                  style={{ height: "90px" }}
                  className="d-flex justify-content-center align-items-end"
                >
                  {formContent?.moveCordinatorSign?.trim()?.length > 0 && (
                    <img
                      src={`${Bucket}${formContent?.moveCordinatorSign}`}
                      height={80}
                      width={200}
                      style={{
                        maxHeight: "80px",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </div>
                <div
                  style={{
                    borderTop: "1px solid #000",
                    marginTop: "10px",
                    width: "80%",
                    margin: "10px auto",
                  }}
                ></div>
                <p className="my-1">
                  <b>{"Move Coordinator"}</b>
                </p>
              </Grid>
              <Grid item xs={12} sm={6} className="text-center">
                <div
                  style={{ height: "90px" }}
                  className="d-flex justify-content-center align-items-end"
                >
                  {formContent.clientSign != "" &&
                    formContent.clientSign != undefined && (
                      <img
                        src={`${Bucket}${formContent.clientSign}`}
                        height={80}
                        width={200}
                        style={{
                          maxHeight: "80px",
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                      />
                    )}
                </div>
                <div
                  style={{
                    borderTop: "1px solid #000",
                    marginTop: "10px",
                    width: "80%",
                    margin: "10px auto",
                  }}
                ></div>
                <p className="my-1">
                  <b>{"Customer/Authorized"}</b>
                </p>
              </Grid>
            </Grid>
          </PremiumCard>
        </PremiumPublicLayout>
      ) : (
        <div className="no-print">
          {isLoading ? (
             <div className="d-flex justify-content-center p-5">
               Loading...
             </div>
          ) : (
            <div className="d-flex justify-content-center p-5 text-danger">
               Ooops... Something went wrong or data is unavailable.
            </div>
          )}
        </div>
      )}

      <PrintComponent>
        <PackingRequestPageDownload
          id="content-id"
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>

      {/* Snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      {/* Add signature Modal */}
      {isSignCanvas && (
        <MySignatureCanvas
          open={isSignCanvas}
          onClose={() => {
            setSignCanvas(false);
          }}
          onSuccess={(file) => {
            if (!isLoading) uploadFile(file);
          }}
        />
      )}
    </>
  );
};

export default PackingRequestPagePreview;
